export enum HiProjectType {
  NewOrReplace = 'new_or_replace',
  ServiceOrRepair = 'service_or_repair',
  OtherType = 'misc_hi_project',
  Unsure = 'customer_unsure',
  Initial = '',
}
